import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { KeyRound, ShieldCheck } from 'lucide-react';
import api from '@/lib/api';
import { toast } from 'sonner';

export default function AdminRecover() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', recovery_code: '', new_password: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (form.new_password !== form.confirm) return toast.error('New passwords do not match');
    setSaving(true);
    try {
      await api.post('/admin/access/recover', {
        username: form.username,
        recovery_code: form.recovery_code,
        new_password: form.new_password,
      });
      toast.success('Password reset. You can sign in now.');
      navigate('/admin', { replace: true });
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Invalid recovery credentials');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-auth">
      <div className="admin-auth-card">
        <div className="admin-auth-mark"><ShieldCheck size={25} /></div>
        <div className="admin-eyebrow"><KeyRound size={13} /> Secure recovery</div>
        <h1>Reset a team password</h1>
        <p>Use the one-time recovery code issued by the RESQLY main account.</p>
        <div className="admin-auth-form">
          <label><span>Username / ID</span><input autoComplete="username" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} /></label>
          <label><span>Recovery code</span><input value={form.recovery_code} onChange={(e) => setForm({ ...form, recovery_code: e.target.value.toUpperCase() })} /></label>
          <label><span>New password</span><input type="password" autoComplete="new-password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} /></label>
          <label><span>Confirm password</span><input type="password" autoComplete="new-password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} /></label>
          <button className="admin-lux-button wide" onClick={submit} disabled={saving}>{saving ? 'Resetting…' : 'Reset password'}</button>
        </div>
        <Link className="admin-auth-link" to="/admin">Back to admin login</Link>
      </div>
    </div>
  );
}
